import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlass = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22.996 22.901", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#404040", stroke: "#fff", strokeWidth: "0.9px", d: "M36.164 34.217l-5.234-5.235a8.82 8.82 0 0 0 1.739-5.357 9.007 9.007 0 1 0-3.687 7.306l5.235 5.235a1.346 1.346 0 0 0 1.949 0 1.346 1.346 0 0 0 0-1.949zm-12.538-4.33a6.261 6.261 0 1 1 6.261-6.261 6.234 6.234 0 0 1-6.261 6.261z", opacity: 0.9, transform: "translate(-14.132 -14.132)" }));
const ForwardRef = forwardRef(SvgMagnifyingGlass);
export { ForwardRef as ReactComponent };
